import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "labelProps", "id", "name"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import FieldWrapper from '../FieldWrapper/FieldWrapper';
import { extractFieldStyleProps } from '../helpers/omit';
import useId from '../helpers/useId';
import Label from '../Label/Label';
import RadioButton from '../RadioButton/RadioButton';
var RadioButtonFieldBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var label = props.label,
      labelProps = props.labelProps,
      id = props.id,
      name = props.name,
      radioButtonProps = _objectWithoutProperties(props, _excluded);

  var styleProps = extractFieldStyleProps(radioButtonProps);
  var radioButtonId = useId(id, name);
  return /*#__PURE__*/React.createElement(FieldWrapper, Object.assign({}, styleProps, {
    $gap: 3
  }), /*#__PURE__*/React.createElement(RadioButton, Object.assign({
    ref: ref,
    id: radioButtonId,
    name: name
  }, radioButtonProps)), /*#__PURE__*/React.createElement(Label, Object.assign({}, labelProps, {
    htmlFor: radioButtonId
  }), label));
});
export var RadioButtonField = /*#__PURE__*/styled(RadioButtonFieldBase).withConfig({
  displayName: "RadioButtonField"
})(["", "{cursor:", ";padding-left:8px;color:", ";}"], Label, function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return p.disabled && p.theme.colors.mediumGray;
});
RadioButtonField.propTypes = {
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  labelProps: PropTypes.object,
  id: PropTypes.string
};
export default RadioButtonField;